import { Stripe } from 'stripe';
import { SubscriptionPlan } from './Subscriptions';
import { UserFeatures } from '../../constants/userFeatures';
import { RequiresAction } from './OrderDocument';
import { ClientInvoiceData } from './ClientInvoiceData';
export interface UserOnboarding {
  loginOnlyByLink: boolean;
  showPasswordBanner: boolean;
}

export type Language = 'pl' | 'en';

export interface SubscriptionPlanDetailsDocument {
  name: SubscriptionPlan;
  clients: number;
  products: number;
  monthlyTransactions: number;
  presentationsMonthly: number;
  uploadLimitAsBytes: number;
  ocrMonthly?: number;
  gradingMonthly?: number;
  features: UserFeatures[];
}

export interface ShortSubscriptionInfo {
  status: Stripe.Subscription.Status;
  currentPeriodStart: number;
  currentPeriodEnd: number;
  updatedAt: number;
  id: string;
  plan: SubscriptionPlanDetailsDocument;
  latestConnectedInvoiceId?: string | null;
  requiresAction?: RequiresAction | null;
  defaultPaymentMethod: string | null;
  priceId: string;
  cancelAtPeriodEnd?: boolean;
}

export interface FreeSubscriptionInfo {
  status: 'active';
  currentPeriodStart: number;
  currentPeriodEnd: null;
  updatedAt: number;
  id: null;
  plan: SubscriptionPlanDetailsDocument;
  latestConnectedInvoiceId?: never;
  requiresAction?: RequiresAction | null;
  defaultPaymentMethod: string | null;
  priceId: null;
  cancelAtPeriodEnd?: never;
}

export type CountryCode = string;

export enum ProductsListVariant {
  Grid = 'grid',
  Horizontal = 'horizontal',
}

export enum UserType {
  Student = 'student',
  Teacher = 'teacher',
  PrivateTeacher = 'private_teacher',
  PrivateSchoolOwner = 'private_school_owner',
}

export interface RegistrationTrackingData {
  eventId: string;
  eventTime: number;
  sourceUrl: string;
  userAgent: string;
  fbp: string | null;
  fbc: string | null;
}

export interface UserDocument {
  email: string;
  contactEmail: string | null;
  firstName: string;
  lastName: string | null;
  avatarUrl: string[] | null;
  uid: string;
  mobileFcmTokens: string[] | null;
  webFcmTokens: string[] | null;
  createdAt: Date;
  updatedAt: Date;
  termsAndPolicyAcceptDate: Date | null;
  /** Throttles verification-email resends; set server-side only. */
  lastVerificationEmailSentAt?: Date | null;
  onboarding?: UserOnboarding;
  termsAndPrivacyPolicy: boolean;
  stripeCustomerId?: string;
  country?: CountryCode;
  features?: UserFeatures[];
  ip?: string | null;
  subscription?: ShortSubscriptionInfo | FreeSubscriptionInfo | null;
  lang?: Language;
  timezone?: string;
  invoiceData?: ClientInvoiceData;
  phoneNumber?: string;
  referredBy?: string;
  userType?: UserType;
  /** Application events used by the MailerLite onboarding and limit workflows. */
  marketing?: {
    everCheckedWork?: boolean;
    gradingLimitReached?: boolean;
    gradingLimitEventId?: string;
  };
  /** Browser/server metadata used to deduplicate registration conversions. */
  registrationTracking?: RegistrationTrackingData;
  /** Denormalized from SchoolMemberDocument so a user's schools are known without scanning every school. */
  schoolIds?: string[];
}
